import * as React from 'react';
import '../../styles/hcldx.scss'

const DeployedToHcldx = () => {
    return (<React.Fragment></React.Fragment>);
};

export default DeployedToHcldx;